import { Box, FormHelperText, Grid2 } from '@mui/material';
import Title from 'modules/Pricing/components/Title';
import { Field, Form } from 'react-final-form';
import ActionButtons from '../ActionButtons';
import { usePriceGroup } from 'core/contexts/priceGroup';
import { useMemo, useState } from 'react';
import { BookingOrigin } from '@utriper/core';
import { useTranslation } from 'react-i18next';
import { Label } from '../../styles';
import { SelectCheckbox } from '@utriper/core-ui';

const OriginsForm = ({ priceGroupId, handleClose }) => {
    const { i18n, t } = useTranslation();
    const translate = (key) => t(`price_group_id.origins_form.${key}`);
    const { origins, submittingPriceGroup, updatePriceGroupOrigins } = usePriceGroup();
    const [submitted, setSubmitted] = useState(false);

    const comingSoonLabel = t('soon');
    const originOptions = useMemo(
        () =>
            BookingOrigin.getValidOrigins().map((bkOrigin) => {
                const disabled = BookingOrigin.isOTABooking(bkOrigin);
                const name = BookingOrigin.getTranslatedName(BookingOrigin.types, bkOrigin, i18n.language);

                return {
                    id: bkOrigin,
                    name: disabled ? `${name} (${comingSoonLabel})` : name,
                    disabled,
                };
            }),
        [i18n.language, comingSoonLabel]
    );
    const initialOrigins = useMemo(() => originOptions.filter((originOption) => origins.includes(originOption.id)), [originOptions, origins]);

    const validateForm = (values) => {
        const errors = {};

        if (!Array.isArray(values?.origins) || values.origins?.length <= 0) {
            errors.origins = translate('validate_form.origins');
        }

        return errors;
    };

    const handleSubmit = async (values) => {
        await updatePriceGroupOrigins(priceGroupId, values.origins);
        handleClose();
    };

    return (
        <Form
            key={`price-group-form-origins-${priceGroupId}`}
            onSubmit={handleSubmit}
            initialValues={{ origins: initialOrigins }}
            validate={validateForm}
            render={({ values, errors, handleSubmit, form }) => {
                const handleChangeOrigins = (newValues) => {
                    form.change('origins', [...newValues]);
                };

                return (
                    <form key={`price-group-form-origins-${priceGroupId}`} onSubmit={handleSubmit} noValidate>
                        <Box component="section" py={2}>
                            <Title title={translate('title')} description={translate('description')} />

                            {/* Form */}
                            <Grid2 container direction="column" justifyContent="flex-start" alignItems="flex-start" gap="8px" mt="24px">
                                <Grid2 container width="100%" direction="column" justifyContent="flex-start" alignItems="flex-start" gap="4px">
                                    <Label>{translate('form.origins')}</Label>
                                    <Field name="origins" component={SelectCheckbox} options={originOptions} values={values?.origins ?? []} label={translate('form.origins_label')} onChange={handleChangeOrigins} hasError={submitted && errors?.origins} />
                                    {submitted && errors?.origins && <FormHelperText error={submitted && errors?.origins}>{errors.origins}</FormHelperText>}
                                </Grid2>
                            </Grid2>

                            <ActionButtons
                                handleSubmit={(e) => {
                                    setSubmitted(true);
                                    return handleSubmit(e);
                                }}
                                handleClose={(e) => {
                                    handleClose();
                                    return form.reset(e);
                                }}
                                submitting={submittingPriceGroup}
                                labelNext={translate('update_origins_button')}
                            />
                        </Box>
                    </form>
                );
            }}
        />
    );
};

export default OriginsForm;
